import React, { useMemo } from 'react';
import RenderImg from '@op/components/RenderImg';
import ChannelLabel, { ChannelIconType } from '@op/components/ChannelLabel';
import TextClamp from '@opm/components/TextClamp';
import URLShare from '@opm/components/URLShare';
import { DefaultImg } from '@op/constants/defaultImg';
import useIntls from '@opm/hooks/useIntls';
import { DBO_TM, DBO_U } from '@op/utils/format';
import CommonBubble from '@home/components/CommonBubble';
import { getMemeRegionCode } from '@opm/utils/language';
import { getMemeTimeInfo } from '@opm/pages/Memes/utils';

interface IMemeInfoCellProps {
  record: any;
  isEn: boolean;
  onTitleClick?: (record: any) => void;
}

function MemeInfoCell({ record, isEn, onTitleClick }: IMemeInfoCellProps) {
  const { intl } = useIntls();
  const title = useMemo(
    () => isEn ? record.title : (record.title_zh || record.title),
    [isEn, record.title, record.title_zh],
  );
  const region = useMemo(
    () => getMemeRegionCode(isEn ? 'en' : 'zh', record),
    [isEn, record],
  );

  const timeInfo = useMemo(
    () => getMemeTimeInfo(record.channels, record.hottest_time, record.min_release_time),
    [record.channels, record.hottest_time, record.min_release_time],
  );

  return (
    <div className="dbom-meme-info">
      {/* 封面图 */}
      <div className="dbom-meme-info-cover">
        <RenderImg
          coverImage={record.raw_cover}
          defaultImage={DefaultImg.VIDEO}
          className="dbom-meme-info-cover-img"
          style={{
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'contain'
          }}
          {...(record.raw_url ? {
            onClick: (e: React.MouseEvent) => {
              e.stopPropagation();
              DBO_U.open(record.raw_url);
            },
          } : {})}
        />
        {record.raw_url && (
          <URLShare
            url={record.raw_url}
            className="dbom-meme-info-share"
            iconClassName="dbom-meme-info-share-icon"
          />
        )}
      </div>
      <div className="dbom-meme-info-content">
        {/* 标题 - 点击跳转详情页 */}
        <div className="dbom-meme-info-title-row">
          <TextClamp
            rowNum={2}
            text={title}
            className={`dbom-meme-info-title dbom-meme-info-title--clickable`}
            onClick={(e) => {
              e.stopPropagation();
              onTitleClick?.(record);
            }}
          />
        </div>
        {/* 平台 Icon + 发现时间 */}
        <div className="dbom-meme-info-meta">
          {record.channels?.map((ch: string) => (
            <ChannelLabel
              key={ch}
              channel_name={ch as ChannelIconType}
              showText={false}
              iconStyle={{ width: 16, height: 16 }}
            />
          ))}

          {region && (
            <span className="dbom-meme-info-region">{region}</span>
          )}
        </div>
        {timeInfo?.time && (
          <CommonBubble content={intl({ id: timeInfo.labelKey })}>
            <span className="dbom-meme-info-date">
              {DBO_TM.sFormat(timeInfo.time)}
            </span>
          </CommonBubble>
        )}
      </div>
    </div>
  );
}

export default React.memo(MemeInfoCell);
